module.exports = __webpack_public_path__ + "img/019-ceuta.52485d6d.svg";